import axios from "../utils/axios";
import {requests} from "../utils/urls";

export const getOtp = async (values) => {
    try {
        const response = await axios.post(requests.auth.getOtp, values);
        return response;
    } catch (e) {
        return e.response;
    }
};
export const getUser = async () => {
    try {
        const response = await axios({
            method: 'GET',
            url: requests.auth.getUser,
        });
        return response;
    } catch (e) {
        return e.response;
    }
};
export const sendOtp = async (values) => {
    try {
        const response = await axios.post(requests.auth.loginOrRegister, values);
        return response;
    } catch (e) {
        return e.response;
    }
};

export const loginUserPass = async (values) => {
    try {
        const response = await axios.post(requests.auth.loginUserPass, values);
        return response;
    } catch (e) {
        return e.response;
    }
};

export const checkOtp = async (username, code) => {
    try {
        const response = await axios.get(requests.auth.checkOtp(username,code));
        return response;
    } catch (e) {
        return e.response;
    }
};

export const forgetsPassword = async (values) => {
    
    try {
        const response = await axios.patch(requests.auth.forgetPassword,values);
        return response;
    } catch (e) {
        return e.response;
    }
};